export default __webpack_public_path__ + "static/media/Astral.4c8b9c2a.png";